module.exports = __webpack_public_path__ + "static/media/addVehicle.c446d15a.svg";